export default '2.7.0';



// WEBPACK FOOTER //
// ./src/lib/version.js